class MiniCartButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent("mini-cart:open"));
    });
  }
  connectedCallback() {
    /* Open mini-cart if URL contains 'minicart' parameter */
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("minicart")) {
      window.addEventListener("load", (event) => {
        this.openMinicart();
      });
    }
  }

  openMinicart() {
    document.dispatchEvent(new CustomEvent("mini-cart:open"));
  }
}

if (!customElements.get("mini-cart-button")) {
  customElements.define("mini-cart-button", MiniCartButton);
}
